var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 275,
    height: 183,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M0 0L7 8L0 8C0 11.3627 -0.715839 14.2037 3 15C-1.83414 20.801 7.22478 34.4496 10 40C17.3664 54.7327 26.9189 69.3243 36 81C39.158 85.0602 40.8666 91.9713 44 96C46.9403 99.7804 55.0075 107.97 54 112L60.3333 122L80 149L81 149L78 118C72.9545 115.165 65.5064 106.555 64 101L49 87L50 85L50 84L49 84L49 86L48 86L40 69L34 62L30 60C30.2901 57.863 27.7927 49.427 30.0363 48.7677C33.9341 47.6224 41.1429 59.2405 43.1628 61.7407C53.7713 74.8724 71.0937 95.5618 75 112L76 112L78 112L79 112L80 105L76.6096 85L57.1196 58L48 48C45.3505 29.8427 24.1338 17.2751 19 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M19 0C22.221 17.7452 43.4147 30.3146 48 48C53.784 51.0047 56.8169 58.7815 60.5586 64C71.2541 78.9167 77.9494 85.9073 78 105L79 105L74.1698 58L73 6L72 6L69 16L67 8L64 9L56 0L19 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M56 0L64 9L67 8L69 16C73.6949 12.9563 72.5304 5.01639 72 0L56 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M72 0L72 4L73 4L72 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M73 0L77 76L78 76L79 73C94.7957 100.74 119.962 123.405 138.846 149C146.203 158.972 156.319 170.647 159 183L181 183L178 77L176 41L173 32L172 32L169 24L160 17C160.76 11.9524 153.29 1.02104 147.96 0.148148C124.329 -3.72182 96.9763 0 73 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M151 0L160 17L169 24L172 32L173 32L174 30L175 35C180.107 22.3578 163.554 0.044342 151 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M159 0C164.322 9.37894 173.476 16.5626 174 28L175 28L174 0L159 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M174 0L174 11L175 11L174 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M175 0L178 90L179 90L178 44L182 48L183 48L183 46L184 46L196.921 65.9954L217.829 104.424L232 128C249.057 136.865 252 166.393 252 183L275 183C275 171.742 275.128 151.838 264 146C264.617 138.376 258.88 131.932 254.871 125.91C248.11 115.756 241.805 105.856 234.579 95.9853C230.884 90.9391 225.595 86.1174 224 80L220 80L200.541 51.9606L184.324 23.1698L176.585 12.8711L175 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M176 0C176 30.7275 207.87 53.294 220 80L224 80C224.92 86.285 230.186 90.99 233.86 95.9853C241.345 106.165 247.758 116.453 254.871 126.83C258.712 132.434 264.219 138.858 264 146C272.188 152.309 272.994 160.179 273 170L275 170L275 86L272 86C270.817 77.8492 261.756 71.6327 256.684 65.6211C248.629 56.0726 243.232 44.3798 236.145 34.1659C232.752 29.2762 229.886 20.8404 224 19L216 4L206.749 5.49306L198.91 0.148148L176 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M202 0C205.229 7.43784 209.352 5.80959 216 4L224 19L233.454 31.5756L256.025 65.6211L272 86L275 86L274.451 49.2863L265.539 37.0108L247 0L202 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M247 0C248.295 6.52766 252.931 12.2345 256.138 18C261.626 27.8648 264.64 42.0076 275 48L271 0L247 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M271 0L275 9L275 0L271 0M0 2L0 8L7 8L0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M73 56L70 38L66 40L65 33L64 33L63 35C59.0074 26.28 49.5646 10.8071 40 8L40 4C32.2621 6.57025 39.6509 14.682 42.169 19.0039C47.8106 28.6865 55.3188 37.8912 62.5949 46.385C65.7169 50.0294 68.3035 54.4802 73 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M73 11L73 14L74 14L73 11M174 11L174 18L175 18L174 11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M8 13L4 15L8 26L12 25C9.95236 21.3119 9.95237 18.6881 12 15L8 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M73 14L73 24L74 24L73 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M111 14L114 18L111 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M0 15C0 27.3698 -3.78051 47.0873 0.814815 58.5756C13.8463 91.1544 41.3837 118.812 60.3434 148C67.1824 158.529 75.8202 170.754 79 183L90 183L82 136L81 136L81 149L80 149L60.4861 121L54 112C53.3862 104.612 46.872 99.0472 43.294 92.9097C33.1518 75.5129 20.312 60.0657 11.0602 42C7.24285 34.546 0.311644 23.6051 3 15L0 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M170.333 18.6667L170.667 19.3333L170.333 18.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M73.3333 24.6667L73.6667 25.3333L73.3333 24.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M119 24L120 25L119 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M175 24L175 29L176 29L175 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M15 29L15 32L16 32L15 29M21 32L20 42C24.0467 39.9096 25.4487 36.3884 26 32L21 32M15.3333 34.6667L15.6667 35.3333L15.3333 34.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M176.333 37.6667L176.667 38.3333L176.333 37.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M28 39L28 40L31 40L28 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M176 39L176 43L177 43L176 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M176 43L176 46L177 46L176 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M178 44C178 65.9626 182.98 90.5622 179 112L180 112L180 110L181 110L180 145L182 144L182 183L252 183C252 166.647 250.696 151.522 240.66 137.884C237.831 134.04 236.847 129.517 232 128C231.364 118.526 222.683 111.245 217.829 103.576C211.832 94.0985 208.826 82.8468 202.83 73.4552C197.463 65.0494 186.674 55.4165 184 46L183 46L183 48L182 48L178 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M30 60L34 62L48 86L49 86L49 84L50 84L49 87L64 101C64.7946 106.436 72.6474 116.16 78 118L80 128L81 128L80 107L79 107L79 112L78 112C77.2127 109.953 76.7873 109.953 76 112C68.0207 94.0882 55.0536 76.4943 43.1628 60.8711C41.1965 58.2877 33.7679 46.5321 29.5795 48.4931C27.04 49.682 30.019 57.6479 30 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M74 52L74 58L75 58L74 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M74 58L74 61L75 61L74 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M0 59L0 120L9.52392 135.576L31.8835 168L40.6343 181.972L52 183L79 183C77.3672 172.755 69.6026 161.731 64.1921 153C51.0529 131.796 35.1107 112.729 21.3997 92C15.4199 82.9596 8.88653 64.821 0 59M177 61L178 62L177 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M177 62L177 67L178 67L177 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M75 66L76 67L75 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M75.3333 67.6667L75.6667 68.3333L75.3333 67.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M177 67L177 75L178 75L177 67M76 71L76 73L78 73L76 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M39.3333 72.6667L39.6667 73.3333L39.3333 72.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M76.3333 73.6667L76.6667 74.3333L76.3333 73.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M78 73L78 86L79 86L80 84C95.0541 119.789 131.856 145.489 144 183L159 183C157.743 173.937 151.055 165.216 145.921 157.83C133.485 139.938 118.565 124.156 105.231 106.985C96.7397 96.0499 88.8807 81.5819 78 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M77 78L77 81L78 81L77 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M78 80L78 83L79 83L78 80M79 84L81.9105 128L83.8542 154L102 183L119 183L104 152L127.599 181.972L144 183C141.27 169.929 130.903 157.797 123.515 146.985C109.688 126.749 96.4243 101.137 79 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M78.3333 86.6667L78.6667 87.3333L78.3333 86.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M78 88L79 89L78 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M178 92L178 97L179 97L178 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M79 95L79 100L80 100L79 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M179 96L179 110L180 110L181 96L179 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M178 97L178 104L179 104L178 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M75 98L76 99L75 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M79 100L79 105L80 105L79 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M180 110L180 139L181 139L180 110M58 112L59 113L58 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M179 112L179 116L180 116L179 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M80.3333 115.667L80.6667 116.333L80.3333 115.667M179 116L179 121L180 121L179 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M80 117L80 120L81 120L80 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M184 117L184 128L186 128L184 117M0 120L0 161C0 169.698 -1.06205 176.825 7.57562 181.697C15.3233 186.067 31.216 183 40 183C33.0593 159.36 9.66841 144.071 3 120L0 120M71.3333 121.667L71.6667 122.333L71.3333 121.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M81 124L81 128L82 128L81 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M70 127L72 130L70 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M81 128L81 134L82 134L81 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M91 133L92 134L91 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M77 137L78 138L77 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M96.6667 141.333L97.3333 141.667L96.6667 141.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M182 143L183 144L182 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M82 144L82 148L83 148L82 144M98.3333 144.667L98.6667 145.333L98.3333 144.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M181 144L181 173L182 173L181 144M184 144L183 162L184 162C185.953 157.39 188.26 147.722 184 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M180 145L180 165L181 165L180 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M100 147L101 152L105 151L100 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M82 148L82 152L83 152L82 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M104 152C104.747 162.756 115.948 182.961 127 183C124.249 174.636 112.722 154.684 104 152M83 154C84.6266 162.354 92.7708 181.449 102 183C99.7252 173.292 90.3979 160.567 83 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M83.3333 156.667L83.6667 157.333L83.3333 156.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M191 160L191 172L192 172L191 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M84.3333 161.667L84.6667 162.333L84.3333 161.667M85 163L90 183L98 183L85 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9aaa9",
      stroke: "none"
    },
    d: "M180 165L180 171L181 171L180 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#678d71",
      stroke: "none"
    },
    d: "M144 167L145 168L144 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#036426",
      stroke: "none"
    },
    d: "M181 175L181 183L182 183L181 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#077e35",
      stroke: "none"
    },
    d: "M0 176L0 183L8 183L0 176z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.2bbe48295f85b8524698a2c257fd2ef3.svg";
export { ForwardRef as ReactComponent };